export function getDataGlobalByKey(lang: string, optionK: string, optionG: string): any {
  if (lang == 'vi-VI') lang = 'vi-VN'
  const dataGlobal: any = inject('globalSettings')
  return dataGlobal?.live_editor
    .filter((item: any) => item.option_group == optionG && item.language == lang)
    .find((child: any) => child.option_key == optionK)
}
